import { inject, Injectable, Injector, Type } from '@angular/core';
import { SystemEntity } from '@wdx/shared/utils';
import {
    ActivityExportApiService,
    ActivityfileExportApiService,
    AdviserExportApiService,
    AmlriskExportApiService,
    AnswerExportApiService,
    AnswertypeExportApiService,
} from '../services';

@Injectable({ providedIn: 'root' })
export class EntityTypeActionExportResolverService {
    private readonly injector = inject(Injector);

    private serviceMap: Partial<Record<SystemEntity, Type<any>>> = {
        [SystemEntity.Activity]: ActivityExportApiService,
        [SystemEntity.ActivityFile]: ActivityfileExportApiService,
        [SystemEntity.Adviser]: AdviserExportApiService,
        [SystemEntity.AmlRisk]: AmlriskExportApiService,
        [SystemEntity.Answer]: AnswerExportApiService,
        [SystemEntity.AnswerType]: AnswertypeExportApiService,
    };

    getService(entityType: SystemEntity) {
        const serviceType = this.serviceMap[entityType];
        if (!serviceType) {
            return null;
        }

        return this.injector.get(serviceType);
    }
}
